import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { TableModule } from 'primeng/table';
import {DireccionesLocales, DireccionLocalComplementos,
  FormGroupErrorMessageComponent,
  Literales,EstandarDirecciones} from "lib-base";
import {LiteralesService} from "../../services/literales.service";
import {firstValueFrom, forkJoin, lastValueFrom} from "rxjs";
import {DireccionLocalService} from "../../services/direccion-local.service";
import {TranslateService} from "@ngx-translate/core";



@Component({
  selector: 'direcciones',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
    FormGroupErrorMessageComponent,
    TableModule
  ],
  templateUrl: './direcciones.component.html',
  styleUrl: './direcciones.component.scss'
})
export class DireccionesComponent implements OnInit {

  @Input() visible!: boolean;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() direccionResult = new EventEmitter<DireccionesLocales>();
  direccionCompleta!:DireccionesLocales;
  direccionesExistentes:DireccionesLocales[] = [];
  direccionForm!: FormGroup;
  direccionModelo: any[] = [];
  dModeloSelect: any;
  tiposVia!:Literales[];
  letras!: Literales[];
  sufijoLiteral!: Literales[];
  sufijo!: Literales[];
  viaGeneradoraLiteral!: Literales[];
  viaGeneradoraCardinalidad!: Literales[];
  cardinalidad!: Literales[] ;
  tiposComplemento!: Literales[];
  translations:any = {};

  constructor(private fb: FormBuilder,
              private lteralService:LiteralesService,
              private _t:TranslateService,
              private direccionLocalService:DireccionLocalService) {}

  ngOnInit(): void {
    this.initTranslations();
    this.inicializarFormulario();
    this.modeloDireccion();
    this.initLiterales();
  }

  inicializarFormulario(): void {
    this.direccionForm = this.fb.group({
      // Vía principal
      barrio: ['', Validators.required],
      tipoVia: [null, Validators.required],
      viaPrincipal: ['', Validators.required],
      letra: [null],
      sufijo: [null],
      letraSufijo: [null],
      cardinalidad: [null],

      // Vía secundaria
      viaSecundaria: [''],
      letraSecundaria: [null],
      sufijoSecundario: [''],
      cardinalidadSecundaria: [null],

      // Complementos
      complementos: this.fb.array([])
    });

    // Añadir al menos una fila de complementos
    this.agregarComplemento();
  }

  get complementosFormArray(): FormArray {
    return this.direccionForm.get('complementos') as FormArray;
  }

  agregarComplemento(): void {
    this.complementosFormArray.push(
      this.fb.group({
        tipo: [null],
        valor: ['']
      })
    );
  }

  eliminarComplemento(index: number): void {
    this.complementosFormArray.removeAt(index);
  }


  async initLiterales(): Promise<void> {
    this.tiposVia = await this.getLiteralesBySeccion(EstandarDirecciones.TIPO_VIA_PRINCIPAL);
    this.letras = await this.getLiteralesBySeccion(EstandarDirecciones.VIA_PRINCIPAL_LITERAL);
    this.sufijo = await this.getLiteralesBySeccion(EstandarDirecciones.VIA_PRINCIPAL_BIS);//sufijo
    this.sufijoLiteral = await this.getLiteralesBySeccion(EstandarDirecciones.VIA_PRINCIPAL_BIS_LITERAL);//sufijoLiteral
    this.cardinalidad = await this.getLiteralesBySeccion(EstandarDirecciones.VIA_PRINCIPAL_CARDINALIDAD);

    this.viaGeneradoraCardinalidad = await this.getLiteralesBySeccion(EstandarDirecciones.VIA_GENERADORA_CARDINALIDAD);//viaSecundaria Cardinalidad
    this.viaGeneradoraLiteral = await this.getLiteralesBySeccion(EstandarDirecciones.VIA_GENERADORA_LITERAL);//viaSecundaria letra
    this.tiposComplemento = await this.getLiteralesBySeccion(EstandarDirecciones.COMPLEMENTO);
  }


  modeloDireccion(){
    this.direccionModelo.push({
        id: 1,
        direccion: 'GAIRA CALLE 16B BIS C NORTE 78 15 SUR TORRE 8',
        complemento: 'APARTAMENTO 345',
        barrio: 'Gaira',
        tipoViaP: 'CALLE',
        nTipoViaP: 16,
        letra: 'B',
        sufijo: 'BIS',
        letraSufijo: 'C',
        cViaPrincipal: 'NORTE',
        viaSecundaria: '78',
        letraViaSec: '',
        sufijoViaSec: '15',
        cViaSecundaria: 'SUR',
        complemento1: 'TORRE',
        valorC1: '8',
        complemento2: 'APARTAMENTO',
        valorC2: '345'
      },
      {
        id: 2,
        direccion: 'LOS ALMENDROS CALLE 13 A 44',
        complemento: 'EDIFICIO PUNTA DEL ESTE',
        barrio: 'LOS ALMENDROS',
        tipoViaP: 'CALLE',
        nTipoViaP: 13,
        letra: 'A',
        sufijo: null,
        letraSufijo: null,
        cViaPrincipal: null,
        viaSecundaria: 44,
        letraViaSec: 'B',
        sufijoViaSec: 12,
        cViaSecundaria: null,
        complemento1: 'EDIFICIO',
        valorC1: 'PUNTA DEL ESTE',
        complemento2: null,
        valorC2: null
      });
    this.dModeloSelect =  this.direccionModelo[0]
  }

  async initTranslations(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
        barrio: this._t.get('components.direcciones.barrio'),
        tipoVia: this._t.get('components.direcciones.tipo-via'),
        viaPrincipal: this._t.get('components.direcciones.via-principal'),
        letra: this._t.get('components.direcciones.letra'),
        sufijo: this._t.get('components.direcciones.sufijo'),
        letraSufijo: this._t.get('components.direcciones.letra-sufijo'),
        cardinalidad: this._t.get('components.direcciones.cardinalidad'),
        viaSecundaria: this._t.get('components.direcciones.via-secundaria'),
        complemento: this._t.get('components.direcciones.complemento'),
        valorComplemento: this._t.get('components.direcciones.valor-complemento'),
        btnCancelar : this._t.get('components.direcciones.btn-cancelar'),
        btnGuardar : this._t.get('components.direcciones.btn-guardar'),
        direccionConstruida : this._t.get('components.direcciones.direccion-construida'),
        direccionCompleta : this._t.get('components.direcciones.direccion-completa'),
        direccionNoEspeficada : this._t.get('components.direcciones.direccion-no-especificada'),
    }));
  }

  async getLiteralesBySeccion(seccion: string): Promise<Literales[]> {
    return await lastValueFrom(this.lteralService.getBySeccion(seccion));
  }

  closeModal(): void {
    this.direccionForm.reset();
    if(this.visible)this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  guardarDireccion(): void {
    if (this.direccionForm.valid) {
      this.direccionCompleta = {
        barrio: this.direccionForm.get('barrio')?.value?.toUpperCase(),
        direccionTextual: this.getDireccionCompleta(),
        id: {
          direccion: 0,
          identificadorDistrital: 0
        },
        literalesByTipoViaPrincipal: this.direccionForm.get('tipoVia')?.value,
        viaPrincipal: this.direccionForm.get('viaPrincipal')?.value?.toUpperCase(),
        literalesByViaPrincipalLiteral: this.direccionForm.get('letra')?.value,
        literalesByViaPrincipalBis: this.direccionForm.get('sufijo')?.value,
        literalesByViaPrincipalBisLiteral: this.direccionForm.get('sufijoLiteral')?.value,
        literalesByViaPrincipalCard: this.direccionForm.get('cardinalidad')?.value,

        viaGeneradora: this.direccionForm.get('viaSecundaria')?.value?.toUpperCase(),
        literalesByViaGeneradoraLiteral: this.direccionForm.get('letraSecundaria')?.value,
        nomenclatura: this.direccionForm.get('sufijoSecundario')?.value?.toUpperCase(),
        literalesByViaGeneradoraCard: this.direccionForm.get('cardinalidadSecundaria')?.value,
        observacion: '',
        direccionLocalComplementos:
          this.complementosFormArray.value?.filter((it:any) => it.valor?.trim() && it.tipo)?.map((item: any, index:number, array:any[]) => (
           { descripcion: item.valor?.toUpperCase(),
            literales : item.tipo,
            orden: index+1,
          } as  DireccionLocalComplementos
        )),
      }
      this.direccionResult.emit(this.direccionCompleta);
      this.visible  = false;
      this.visibleChange.emit(this.visible);
    } else {
      // Marcar todos los campos como touched para mostrar errores
      Object.keys(this.direccionForm.controls).forEach(key => {
        const control = this.direccionForm.get(key);
        control?.markAsTouched();
      });
    }
  }

  getDireccionCompleta(): string {
    const form = this.direccionForm.value;
    let direccion = '';

    // Vía principal
    if(form.barrio) {
      direccion += this.getBarrio() + ' ';
    }

    if (form.tipoVia?.literal) {
      direccion += (form.tipoVia as Literales).abreviatura + ' ';
    }

    if (form.viaPrincipal) {
      direccion += form.viaPrincipal + ' ';
    }

    if (form.sufijo?.literal) {
      direccion += (form.sufijo as Literales).abreviatura + ' ';
    }

    if (form.letra?.literal) {
      direccion += (form.letra as Literales).abreviatura + ' ';
    }

    if (form.letraSufijo?.literal) {
      direccion += (form.letraSufijo as Literales).abreviatura + ' ';
    }

    if (form.cardinalidad?.literal) {
      direccion += form.cardinalidad.abreviatura + ' ';
    }

    // Vía secundaria
    if (form.viaSecundaria) {
      direccion += form.viaSecundaria + ' ';

      if (form.letraSecundaria?.literal) {
        direccion += (form.letraSecundaria as Literales).abreviatura + ' ';
      }

      if (form.sufijoSecundario) {
        direccion += form.sufijoSecundario + ' ';
      }

      if (form.cardinalidadSecundaria?.literal) {
        direccion += (form.cardinalidadSecundaria as Literales).abreviatura + ' ';
      }
    }

    // Complementos
    if (form.complementos && form.complementos.length > 0) {
      form.complementos.forEach((complemento: any) => {
        if (complemento.tipo?.literal && complemento.valor) {
          direccion += (complemento.tipo as Literales).abreviatura + ' ' + complemento.valor + ' ';
        }
      });
    }

    return direccion.trim();
  }

  consultarDireccionesPosibles() {
    if (this.direccionForm && this.direccionForm.get('tipoVia')?.value != null
      && (this.direccionForm.get('viaPrincipal')?.value?.trim())
      && this.direccionForm.get('viaSecundaria')?.value) {
      const barrio = this.getBarrio();
      this.direccionLocalService.consultaDireccionesPosibles(this.getDireccionCompleta(), barrio)
        .subscribe({
          next: (value) => {
            this.direccionesExistentes = value;
          }, error: err => {
            console.log(err);
          }

        });
    }
  }

  getBarrio(): string {
    return this.direccionForm.get('barrio')?.value?.trim()?.toUpperCase() || '';
  }
}
